import React, { useEffect } from "react";
// import Footer from "../components/Footer";
// import bgimage from "../assets/AboususPageimage.jpg";
import AboutSection from "../components/AboutSection";
import image01 from "../assets/6660(2).jpg";
import MissionAndVisionCards from "../components/MissionAndVisionCards";
import OwnerReview from "../components/OwnerReview";
// import CollegeAtGlanceSection from "../components/CollegeAtGlanceSection";
import { motion } from "framer-motion";
// import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../Slices/LoaderSlice";
// import LogoLoader from "./LogoLoader";
import Ownerimage from "../assets/amitbhai-276x276-1.png";

function Aboutus() {
  const dispatch = useDispatch();
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  // const { isLoading } = useSelector(state => state.loader)
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const runLoader = async () => {
      dispatch(showLoader());
      await sleep(500)
      dispatch(hideLoader());
    };

    runLoader();
  }, [dispatch]);
  const colors = ["#537D5D", "#393E46", "#A08963", "#48A6A7"]
  const array = [];

  const randomColor = () => {
    if (array.length === colors.length) {
      console.log("All colors used");
      return null; // or reset array if desired
    }

    let color;
    do {
      const index = Math.floor(Math.random() * colors.length);
      color = colors[index];
    } while (array.includes(color));

    array.push(color);
    console.log("color", color);
    console.log("array", array);
    return color;
  };
  return (
    <div id="about" className="bg-[#ffffff] w-full min-h-screen">
      <motion.div
        className=""
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: 0.9,
        }}
      >
        {/* <header
          className="flex  relative items-center justify-center py-16 bg-gradient-to-b from-white to-[#f0f0f0] bg-center bg-cover md:h-screen h-[50vh]"
          style={{
            backgroundImage: `url(${bgimage})`,
          }}
        >
          <div className="absolute inset-0 bg-black/70"></div>
          <div className="flex flex-col items-center justify-center z-10">
            <h1 className="font-semibold text-7xl bg-clip-text text-transparent bg-white pb-2 z-10 ">
              About Us
            </h1>
            <p className="text-white text-3xl flex items-center justify-center">
              <span>Home</span>
              <span className="mt-2">
                <MdOutlineKeyboardDoubleArrowRight />
              </span>{" "}
              <span className="text-orange-300"> About us</span>
            </p>
          </div>
        </header> */}
      </motion.div>
      {/* About Us Section */}
      <AboutSection
        title={"About Us"}
        paragraph1={
          "Established in 1997, Vardhman Charitable Trust runs four educational institutions to provide quality education to undergraduate and postgraduate students of commerce, computer application, and education."
        }
        paragraph2={
          "These Educational Institutes are run under the title Lokmanya and are affiliated with Gujarat University. Lokmanya College of Computer Application was the first BCA college granted affiliation by Gujarat University."
        }
        image={image01}
      />
      {/* Mission and Vision */}
      <MissionAndVisionCards />

      {/* OwnerReview */}
      <div id="trustees" className="bg-[#faf8f7]">
        <OwnerReview name={"Shree Amit Thaker"} discription={`Shree Amit Thaker is working as a director in Vardhman charitable trust.`} src={Ownerimage} color={randomColor} />
        <OwnerReview name={"Ms. Hemal Mehta"} discription={`Ms. Hemal Mehta is working as a director in Vardhman charitable trust.`} src={null} color={randomColor} />
        <OwnerReview name={"Shree Vedant Thaker"} discription={`Shree Vedant Thaker is working as a director in Vardhman charitable trust.`} src={null} color={randomColor} />
        <OwnerReview name={"Shree Vinod Chajad"} discription={`Shree Vinod Chajad is working as a director in Vardhman charitable trust.`} src={null} color={randomColor} />
      </div>

      {/* Lokmanya College at Glance section */}
      {/* <CollegeAtGlanceSection title={"Champion School at Glance"} /> */}

      {/* Footer */}
      {/* <Footer /> */}
    </div>
  );
}

export default Aboutus;
